import React from 'react';

// Components
import { Thumbnail } from "shared/components/user";

// utils
import { getUserInitials } from "shared/utils";

// Styles
import styles from './Leads.module.scss';

const LeadCard = ({ className='', item, empty=false }) => {
    if(empty){
        return <div className={ styles.empty } />
    }

    const { status, title, leadOwner, leadContact } = item;
    const initials = getUserInitials(leadContact[0], leadContact[1]);

    return (
        <div className={ className }>
            <h4>{ title }</h4>
            <span className={ styles.status }>{ status }</span>
            <div className={ styles.leadOwner }>
                <span>Lead Owner</span>{ leadOwner[0] }
            </div>
            <div className={ styles.contact }>
                <Thumbnail
                    backgroundColor="#B3B5BD"
                    image=""
                    initials={ initials }
                    size="tiny" />
                { leadContact[0] }
            </div>
        </div>
    )
}

export default LeadCard;
